import { Component, OnInit, NgZone } from '@angular/core';
import { MDCTopAppBar } from '@material/top-app-bar';
import { MDCDrawer } from '@material/drawer';
import { AuthService } from '../services/auth.service';
import * as firebase from 'firebase';
import { Roles } from '../models/Roles';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material';
import { SearchComponent } from '../search/search.component';
import { AllusersComponent } from '../allusers/allusers.component';
import { CreateuserComponent } from '../createuser/createuser.component';
import { CreateclientComponent } from '../createclient/createclient.component';
import { CreatepatientComponent } from '../createpatient/createpatient.component';
import { ReportComponent } from '../report/report.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  drawer: any;
  url: string;
  topAppBar: any;
  user: any;
  uid: any;
  userDBRole: any;
  userEmail: string;
  userName: string;
  realRole: string;
  navOpened: boolean;
  
  constructor(
    public auths: AuthService,
    public router: Router,
    public ng: NgZone,
    public snackBar: MatSnackBar,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.auths.user.subscribe((user) => {
      if (user !== null && user !== undefined) {
        this.uid = user.uid;
        const db = firebase.firestore();
        document.getElementById('nuageMenu').style.display = 'block';
        db.collection('users').where('uid', '==', this.uid).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.user = user;
            this.realRole = doc.data()['role'];
            this.userDBRole = this.getRole(doc.data()['role']);
            this.userName = doc.data()['name'];
            this.userEmail = doc.data()['email'];
            this.setupByRole(this.userDBRole);
          });
        });
      } else if (user === undefined || user === null) {
        document.getElementById('nuageMenu').style.display = 'none';
        document.getElementById('buttonSectionFace').style.display = 'none';
        document.getElementById('buttonSectionIdent').style.display = 'none';
        document.getElementById('buttonSectionPatient').style.display = 'none';
        document.getElementById('usersMenu').style.display = 'none';
      }
    });

    this.topAppBar = MDCTopAppBar.attachTo(document.getElementById('app-bar'));
    this.drawer = MDCDrawer.attachTo(document.querySelector('.mdc-drawer'));
    this.topAppBar.setScrollTarget(document.getElementById('main-content'));
    this.topAppBar.listen('MDCTopAppBar:nav', () => {
      this.drawer.open = !this.drawer.open;
    });

    const listEl = document.querySelector('.mdc-drawer .mdc-list');
    const mainContentEl = document.querySelector('.main-content');

    listEl.addEventListener('click', (event) => {
      this.drawer.open = false;
    });

    mainContentEl.addEventListener('click', (event) => {
      this.drawer.open = false;
    });

    this.auths.drawerOpenO.subscribe((val) => {
      this.drawer.open = val;
    });
  }

  getRole(role: any): string {
    if (role === Roles.clientAdmin)
      return 'Admin'
    else if (role === Roles.client)
      return 'Owner'
    else
      return this.userDBRole
  }

  hideShowById(ids: Array<string>, v: boolean): void {
    ids.forEach((e) => {
      if (document.getElementById(e))
        document.getElementById(e).style.display = v ? 'block' : 'none'
    })
  }

  setupByRole(role: string) {
    if (role === Roles.consultant) {
      this.hideShowById(['buttonSectionFace', 'buttonSectionIdent', 'buttonSectionPatient', 'reportGen'], false)
    } else if (role !== Roles.superUser) {
      this.hideShowById(['buttonSectionIdent', 'reportGen'], false);
      this.hideShowById(['buttonSectionferace', 'buttonSectionPatient', 'usersMenu'], true);
    } else {
      this.hideShowById(['buttonSectionIdent', 'buttonSectionFace', 'usersMenu'], true);
      this.hideShowById(['buttonSectionPatient'], false);
    }
  }

  closeNav() {
    this.drawer.open = !this.drawer.open;
  }

  logout() {
    this.auths.logout();
    this.navOpened = false;
  }

  navigateToConsultant() {
    const dialogRef = this.dialog.open(AllusersComponent, {
      width: '80vw',
      data: null
    });
  }

  navigateToClient() {
    const dialogRef = this.dialog.open(SearchComponent, {
      width: 'auto',
      data: { uid: this.uid, email: this.user.email, realRole: this.realRole }
    });
  }

  navigateToCreateClient() {
    const dialogRef = this.dialog.open(CreatepatientComponent, {
      width: '380px',
      data: null
    });
  }

  VideoConferencing() {
    this.url = 'https://enghouse.vidyocloud.com/join/Hl3gSIPorI';
    window.open(this.url, "_blank");
  }

  ConferenceList() {
    const dialogRef = this.dialog.open(CreateuserComponent, {
      width: '380px',
      data: { 'userType': 'None', 'title': 'List of Conferences', 'button': 'blank', 'screen': 'empty' }
    });

  }

  launchHelp() {
    this.url = 'https://www.merriam-webster.com/dictionary/help';
    window.open(this.url, "_blank");
  }

  createUser(role: string): void {
    let r_dialog: any;
    switch (role) {
      case 'consultant':
        r_dialog = this.dialog.open(CreateuserComponent, {
          width: '380px',
          data: { 'userType': 'Consultant', 'title': 'Create Consultant', 'button': 'Create', 'screen': 'full' }
        });
        break;
      case 'admin':
        r_dialog = this.dialog.open(CreateuserComponent, {
          width: '350px',
          data: { 'userType': 'Admin', 'title': 'Create Admin', 'button': 'Create', 'screen': 'full' }
        });
        break;
      case 'client':
        r_dialog = this.dialog.open(CreatepatientComponent, {
          width: '380px',
          data: null
        });
        break;
      case 'owner':
        r_dialog = null;
        if (this.userDBRole === Roles.superUser) {
          this.navigateToCreateOwner();
        } else {
          this.snackBar.open('You are not authorized to access this page', null, {
            duration: 5000,
          });
        }
        break;
      default:
        break;
    }
    const dialogRef = r_dialog;
  }

  navigateToCreateUser() {
    const dialogRef = this.dialog.open(CreatepatientComponent, {
      width: '380px',
      data: null
    });
  }

  navigateToCreateOwner() {
    const dialogRef = this.dialog.open(CreateclientComponent, {
      width: '380px',
      data: null
    });
  }

  navigateGenerateReport() {
    const dialogRef = this.dialog.open(ReportComponent, {
      width: '70vw',
      data: this.uid
    });
  }
}